import { gql } from '@apollo/client'

/**
 * Open the merchant sign-up wizard (app.rushmyfood.com) as staff, to fill in
 * an application for a restaurant: a new one, or the one with this id. The
 * link carries a 12-hour staff token (backend merchantOnboarding.staffLink).
 */
// view: a signed or rejected one too, to show it locked (the admin's application page).
export const STAFF_LINK = gql`mutation MerchantStaffLink($id: ID, $view: Boolean) { merchantStaffLink(id: $id, view: $view) }`

export async function openInWizard(getLink, id) {
  // Opened before the request, while it still counts as the user's click.
  const tab = window.open('', '_blank')
  try {
    const { data } = await getLink({ variables: { id: id || null } })
    if (tab) tab.location.href = data.merchantStaffLink
    else window.location.assign(data.merchantStaffLink)
  } catch (e) {
    if (tab) tab.close()
    throw e
  }
}
